import { SecurityModel } from 'api';
import * as constants from 'common/constants/fund-ownership';
import { Fund } from 'common/types/fund';
import { rowConfig } from 'pages/CapTable/fund-ownership/data';
import { ReverseParsedFundOwnershipDetail } from 'pages/CapTable/fund-ownership/types';

interface ReferenceDictionary {
  [key: string]: {
    [id: number]: string;
  };
}

const getReferences = ({
  columns,
  funds,
  securities,
}: {
    columns: ReverseParsedFundOwnershipDetail[];
  funds: Fund[];
  securities: SecurityModel[];
}): ReferenceDictionary => {
  let dictionary: ReferenceDictionary = {};
  // any due to dynamic keys
  let fundNames: any = {};
  let securityNames: { [id: number]: string } = {};

  const rows = rowConfig();

  columns.forEach(c => {
    const fund = funds?.find((fund: Fund) => fund.id === c.fund);
    const security = securities?.find(security => security.id === c.security);

    fundNames = {
      ...fundNames,
      [c.fund!]: fund ? fund.name : '',
    };
    securityNames = {
      ...securityNames,
      [c.security!]: security ? security.name : '',
    };
  });

  rows.forEach(row => {
    switch (row.alias) {
      case constants.FUND_ALIAS:
        dictionary = {
          ...dictionary,
          [row.alias]: fundNames,
        };
        break;
      case constants.SECURITY_ALIAS:
        dictionary = {
          ...dictionary,
          [row.alias]: securityNames,
        };
        break;
      default:
    }
  });

  return dictionary;
};

export default getReferences;
